
@if(recipients >= 0){
    <div class="d-flex gx-2 mt-2 align-items-center" (mouseleave)="showAllTeams=false">
        <div class="text-secondary pe-3">
            <i class="fa-solid fa-users"></i>
        </div>
        <div class="">
            <div class="recipients px-3">
                {{recipients}} {{'polls_settings.recipients' | translate}}
            </div>
        </div>
        @if(selectedTeams){
            <div class="team-name ps-2">
                <span class="pe-2 fst-italic fw-normal">{{'polls_settings.from_teams' | translate}}</span>
                @for(team of selectedTeams;  track $index; let last = $last){
                    @if($index < 3){
                      <span>{{team.name}}{{last ? '' :', '}}</span>
                    }
                  }
                  @if(selectedTeams.length > 3){
                    @if(!showAllTeams){
                        <span (mouseover)="showAllTeams=true">
                            {{selectedTeams.length - 3}} {{'polls_settings.show_more' | translate}}
                        </span>
                    }@else{
                        <span>
                            @for(team of selectedTeams; track $index; let last = $last){
                                @if($index >= 3){
                                  <span>{{team.name}}{{last ? '' :', '}}</span>
                                }
                            }
                        </span>
                    }
                  }
            </div>
        }
    </div>
}

